<template>
  <div class="container">
    <r-title class="title">{{ $t('recovery.password') }}</r-title>
    <p class="text">{{ $t('recovery.password.text') }}</p>
    <a-form :form="form" @submit.prevent="handleSubmit" class="container form">
      <email-input v-model="email" />
      <p class="error" v-if="error">{{ error }}</p>
      <a-button
        :disabled="disabled"
        :loading="loading"
        type="primary"
        html-type="submit"
        class="button"
        >{{ $t('submit') }}</a-button
      >
    </a-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import RTitle from '@/components/common/Title.vue';
import EmailInput from '@/components/common/EmailInput.vue';

import { RESTORE_PASSWORD_EMAIL } from '@/store/session/actionTypes';
import { ROUTER_PATHS } from '@/router/constants';

export default {
  components: {
    RTitle,
    EmailInput,
  },
  data() {
    return {
      email: this.$route.query.email,
      disabled: true,
      loading: false,
      error: '',
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'recoveryPassword' });
  },
  provide() {
    return {
      form: this.form,
    };
  },
  created() {
    this.setDisabled();
  },
  updated() {
    this.setDisabled();
  },
  methods: {
    ...mapActions({
      restorePasswordEmail: RESTORE_PASSWORD_EMAIL,
    }),
    async handleSubmit() {
      this.loading = true;

      const data = {
        email: this.email,
        message: this.$t('restore.password.email.sent'),
      };

      try {
        await this.restorePasswordEmail(data);
        this.redirectToSuccessScreen();
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    redirectToSuccessScreen() {
      this.$router.push({
        path: ROUTER_PATHS.SUCCESS_RECOVERY_PASSWORD,
        query: {
          email: this.email,
        },
      });
    },
    setDisabled() {
      this.form.validateFields((err) => {
        if (!err) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/breakpoints';

.container {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.text {
  color: $text-grey;
}

.error {
  text-align: center;
  color: $red;
}

.form,
.button {
  margin: 20px 0 0 0;
}

.title {
  text-align: center;
  margin-bottom: 10px;
}

@media (max-width: $login-base-breakpoint) {
  .text {
    font-size: 14px;
  }
}
</style>
